import { useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Table } from 'reactstrap'
import { enterKeyHandler } from '../../../utils'
import useForm from '../../CustomHooks/FormHook'
import '../Custom.css'
import CustomSelectListInput from '../CustomSelectListInput'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import DateRangeInput from '../DateRangeInput'
import FormHeading from '../FormHeading'
import FormSubmitButton from '../FormSubmitButton'

export default function InvoiceDetailForm({ location }) {
  console.log('InvoiceDetailForm rendered: ', location)

  let init = {
    defenseCounsel: [],
    invoiceDateFrom: '',
    invoiceDateTo: '',
    paidDateFrom: '',
    paidDateTo: '',
  }

  const navigate = useNavigate()
  init = initialFormValues('InvoiceDetailForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  // Scroll error messages into view
  const scrollRef = useRef(null)
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView()
    }
  }, [])

  async function submitSearch() {
    submitFormValues('InvoiceDetailForm', navigate, inputs, 'reports.invoice_detail_rep')
  }

  return (
    <div className="custom-scroll">
      <form className="form" onSubmit={handleSubmit} style={{ margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{ backgroundColor: 'white' }}>
            <FormHeading headingText={'Invoice Detail Report'} />
            <tbody>
              <CustomSelectListInput label='Defense Counsel' handleChange={handleInputChange} modelName="Asbestos" entityName="outside_firm" name='defenseCounsel' multiple={true} blankOption={true} defaultValue={inputs.defenseCounsel} />
              <DateRangeInput label='Invoice Date' name='invoiceDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.invoiceDateFrom} defaultValueTo={inputs.invoiceDateTo} />
              <DateRangeInput label='Paid Date' name='paidDate' handleInputChange={handleInputChange} defaultValueFrom={inputs.paidDateFrom} defaultValueTo={inputs.paidDateTo} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton label='Run Report' />
      </form>
    </div>
  )
}
